export default "/assets/images/mila-feed-03-thumbnail.jpg?a86eb58487f05b1aa49ce10116e53475";